import { render, staticRenderFns } from "./ReclamationReportsPage.vue?vue&type=template&id=4729f47d&"
import script from "./ReclamationReportsPage.vue?vue&type=script&lang=js&"
export * from "./ReclamationReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports